import React, { useEffect } from 'react';
import { getContentType } from '../../../Utils/helper';
import PregnancyCards from '../../PregnancyPage/PregnancyCards';
import {
  BannerTitle,
  GridWrapper,
} from '../../StoreHomePage/BannersGrid/styled';
import {
  fireClickedCardEvent,
  fireServedSectionEvent,
} from '../../../Utils/useFirebase';

export default React.memo(function ParentingHelpfulTools(props) {
  const { data, stage } = props;
  const categoryRedirect = (term_id, section, description, web_url) => {
    fireClickedCardEvent(
      section,
      description,
      getContentType(),
      term_id,
      web_url,
    );
  };
  useEffect(() => {
    if (data?.items > 0) {
      let cardId = [];
      data?.items?.map((element) => {
        element?.items?.map((item) => {
          cardId.push(item?.term_id);
        });
      });
      fireServedSectionEvent(data?.heading, cardId, getContentType());
    }
  }, []);
  return (
    <GridWrapper>
      <BannerTitle>
        <h2>{data?.heading}</h2>
        <h3>{data?.subHeading}</h3>
      </BannerTitle>
      <PregnancyCards
        cardData={data?.items}
        categoryRedirect={categoryRedirect}
        stage={stage}
        sectionName={data?.heading}
      />
    </GridWrapper>
  );
});
